<script setup lang="ts">
import { colors } from '~/utils';

interface Serie {
  name: string;
  data: number[];
}

interface Props {
  title: string;
  height?: number;
  series: Serie[];
  categories: string[];
  valueFormater?: (value: number) => string;
}

const props = defineProps<Props>();

const chartAttrs: any = {
  series: props.series,
  options: {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    colors,
    plotOptions: {
      bar: {
        distributed: true,
      },
    },
    xaxis: {
      categories: props.categories,
      labels: {
        show: false,
      },
    },
  },
};

if (props.valueFormater) {
  chartAttrs.options.yaxis = {
    labels: {
      formatter: (value: number) => {
        if (typeof props.valueFormater === 'function')
          return props.valueFormater(value);
      },
    },
  };
}
</script>
<template>
  <a-card :title="props.title">
    <a-empty v-if="props.categories.length === 0" />
    <apexchart
      v-else
      type="bar"
      :height="props.height"
      v-bind="chartAttrs"
    ></apexchart>
  </a-card>
</template>
